// PDP 3.4 — EDITORIAL CONTENT (copy, imagery, section text). Shopify: section settings,
// blocks and product metafields/metaobjects — see src/data/_SHOPIFY_MAPPING.md.

export const PDP_3_4_CONTENT = {
  whenToUse: "How to use: After cleansing, apply 1 small pump along the orbital bone, outer corner and under-eye area. Wait 2 minutes to absorb before makeup.",
  facts: {
    anchor: "actives-section",
    rows: [
      {
        label: "Benefits",
        value: "Our best-selling moisturizer to deliver immediate hydration and help defend against environmental stressors.",
        link: true,
      },
      {
        label: "Key ingredients",
        value: "Matrixyl + Haloxyl Peptide Complex, Hinokitiol (Beta-T), Stabilized Vitamin C, Vitamin E",
      },
      {
        label: "How to use",
        value: "Use a pea-sized amount. Apply over the entire face, except the eye area. Use twice a day, morning and night, after cleansing and serum application.",
      },
      {
        label: "Reviews",
        value: "I have used Riversol on my face for over a year and absolutely love it! Two days ago I used the reparative spray on my chest area.",
      },
    ],
  },
  marquee: [
    "Matrixyl · Palmitoyl Pentapeptide-4",
    "Hinokitiol · Beta-T",
    "Stabilized Vitamin C",
    "Multi-Peptide Blend",
    "Fragrance-Free",
    "Dermatologist-Developed",
    "For Sensitive Skin",
    "Reduces Puffiness",
  ],
  ugc: {
    heading: "Riversol in Action",
    intro: "Join 115,000 happy customers using Riversol every day in their routine",
    videos: [
      {
        id: "6707819debae4417a2990f0a1b9730ce",
        thumb: "https://www.riversol.com/cdn/shop/files/preview_images/6707819debae4417a2990f0a1b9730ce.thumbnail.0000000000.jpg?v=1781381205&width=800",
        video: "https://www.riversol.com/cdn/shop/videos/c/vp/6707819debae4417a2990f0a1b9730ce/6707819debae4417a2990f0a1b9730ce.HD-720p-3.0Mbps-86478555.mp4?v=0",
      },
      {
        id: "ed6efc4b6f0f4be1b72ed0a865cfc660",
        thumb: "https://www.riversol.com/cdn/shop/files/preview_images/ed6efc4b6f0f4be1b72ed0a865cfc660.thumbnail.0000000000.jpg?v=1781381205&width=800",
        video: "https://www.riversol.com/cdn/shop/videos/c/vp/ed6efc4b6f0f4be1b72ed0a865cfc660/ed6efc4b6f0f4be1b72ed0a865cfc660.HD-720p-1.6Mbps-86478567.mp4?v=0",
      },
      {
        id: "4c038977d26547408999f4e1fb48a347",
        thumb: "https://www.riversol.com/cdn/shop/files/preview_images/4c038977d26547408999f4e1fb48a347.thumbnail.0000000000.jpg?v=1773956868&width=800",
        video: "https://www.riversol.com/cdn/shop/videos/c/vp/4c038977d26547408999f4e1fb48a347/4c038977d26547408999f4e1fb48a347.HD-720p-1.6Mbps-78302330.mp4?v=0",
      },
      {
        id: "72bd9868884948778c77cf98530fb4f1",
        thumb: "https://www.riversol.com/cdn/shop/files/preview_images/72bd9868884948778c77cf98530fb4f1.thumbnail.0000000000.jpg?v=1772641115&width=800",
        video: "https://www.riversol.com/cdn/shop/videos/c/vp/72bd9868884948778c77cf98530fb4f1/72bd9868884948778c77cf98530fb4f1.HD-1080p-2.5Mbps-77141232.mp4?v=0",
      },
      {
        id: "610be86236774523b276bd7efa018af8",
        thumb: "https://www.riversol.com/cdn/shop/files/preview_images/610be86236774523b276bd7efa018af8.thumbnail.0000000000.jpg?v=1773956866&width=800",
        video: "https://www.riversol.com/cdn/shop/videos/c/vp/610be86236774523b276bd7efa018af8/610be86236774523b276bd7efa018af8.HD-720p-1.6Mbps-78302326.mp4?v=0",
      },
    ],
  },
  storyA: {
    eyebrow: "The targeted eye treatment",
    title: "Brighter, Smoother, Firmer",
    body: "Our targeted eye treatment is formulated to visibly brighten, smooth, and firm the delicate eye area. Powered by Matrixyl, peptides, stabilized vitamin C, and hinokitiol, it targets the look of dark circles, puffiness, and fine lines with a lightweight, fast-absorbing texture. After cleansing, a single small pump dotted along the orbital bone and under-eye area sinks in within two minutes — leaving skin comfortable, hydrated and ready for makeup.",
    indicators: [
      { icon: "sun", label: "Morning & night" },
      { icon: "clock", label: "2 min to absorb" },
      { icon: "feather", label: "Lightweight texture" },
    ],
    image: "https://cdn.shopify.com/s/files/1/0821/1399/files/Rectangle_1744_324fd431-fcf1-44ef-a93c-eccd8484a2e1.png?v=1778007698",
    imageAlt: "Eye Repair Treatment lifestyle",
    detailImage: "https://cdn.shopify.com/s/files/1/0821/1399/files/Eye_Repair_Treatment.jpg?v=1776098164",
    detailAlt: "Eye Repair Treatment texture close-up",
  },
  collage: {
    eyebrow: "Multi-peptide, one treatment",
    headline: "Targeted care for the delicate eye area.",
    body: "An advanced antioxidant and multi-peptide blend — Matrixyl, peptides, stabilized vitamin C and hinokitiol — works together in a lightweight, fast-absorbing texture to help brighten, smooth and firm.",
    centerImage: "https://cdn.shopify.com/s/files/1/0821/1399/products/eye-repair.png?v=1776097214",
    centerAlt: "Eye Repair Treatment product",
    topImage: "https://customer-assets-eiarnc6j.emergentagent.net/job_76fde4e1-b224-41fa-b1e0-b502822df34b/artifacts/32jqa6ea_Image%20Sep%2019%2C%202026%2C%2002_40_36%20AM%20%281%29.png",
    topAlt: "Eye Repair Treatment foam texture",
    leftImage: "https://cdn.shopify.com/s/files/1/0821/1399/files/Rectangle_1744_324fd431-fcf1-44ef-a93c-eccd8484a2e1.png?v=1778007698",
    leftAlt: "Eye Repair Treatment in use",
    rightImage: "https://cdn.shopify.com/s/files/1/0821/1399/products/eye-repair.png?v=1776097214",
    rightAlt: "Eye Repair Treatment product",
    twoBanners: true,
  },
  storyB: {
    eyebrow: "Dermatologist-developed",
    titleLines: ["Meet Dr. Rivers, the award-winning", "dermatologist behind Riversol"],
    p1: "Riversol products are dermatologist-developed for sensitive skin. Dr. Jason Rivers first created Riversol for patients who struggled to find skincare that delivered results without unnecessary irritation.",
    p2: "That same philosophy guides the Eye Repair Treatment — fragrance-free, paraben-free and made with low-irritant ingredients chosen to support comfort in the most delicate area of the face.",
    personName: "Dr. Jason Rivers",
    personRole: "Founder · Board-certified dermatologist",
    personInitials: "Dr.\nRivers",
    image: "https://cdn.shopify.com/s/files/1/0821/1399/files/Dr._Rivers_1.png?v=1774575652",
    imageAlt: "Dr. Jason Rivers",
    badgeBig: "Beta-T",
    badgeText: "Riversol's signature hinokitiol antioxidant, from the Pacific red cedar.",
    imageRight: false,
  },
  actives: {
    eyebrow: "Ingredients",
    titleLines: ["Actives that target", "the eye area"],
    tabs: [
      { id: "spotlight", label: "Ingredient Spotlight" },
      { id: "without", label: "Formulated Without" },
      { id: "full", label: "Full List of Ingredients" },
    ],
    // Tab 1 — 6 spotlight items in a swipeable row (image, name, description). Client copy; do not edit.
    items: [
      {
        name: "Hinokitiol (Beta-T)",
        benefit: "Helps improve skin clarity, brighten the look of dark spots and support a more even-looking complexion through its antioxidant properties.",
        image: "https://www.riversol.com/cdn/shop/files/hinokitiol.png?v=1772154769&width=600",
      },
      {
        name: "Matrixyl (Palmitoyl Pentapeptide-4)",
        benefit: "A multi-peptide that supports smoother-looking skin and the appearance of firmness around the eye.",
        image: "https://static.prod-images.emergentagent.com/jobs/76fde4e1-b224-41fa-b1e0-b502822df34b/images/885c01c54bc92f9cabc06586d677afbfbf908676d013c1d30adbf52346c887b7.jpeg",
      },
      {
        name: "Palmitoyl Oligopeptide",
        benefit: "Works alongside Matrixyl to help refine the look of fine lines and crow's feet.",
        image: "https://static.prod-images.emergentagent.com/jobs/76fde4e1-b224-41fa-b1e0-b502822df34b/images/4ddd6d6ac69f034c6c50c9e7fd524304bbfcd37901aad0ed8ac66c9639ee6f01.jpeg",
      },
      {
        name: "Stabilized Vitamin C",
        benefit: "A photostable vitamin C that delivers lasting antioxidant protection to reduce the look of fine lines, wrinkles, and dark spots.",
        image: "https://www.riversol.com/cdn/shop/files/vitamin_c_9cbe2d53-d1c5-44f4-9939-f6b748070640.png?v=1772845187&width=600",
      },
      {
        name: "Vitamin E",
        benefit: "A potent antioxidant that reduces the look of sun damage in sensitive skin, while hydrating and replenishing the skin's moisture barrier.",
        image: "https://static.prod-images.emergentagent.com/jobs/76fde4e1-b224-41fa-b1e0-b502822df34b/images/f2875b68e6cecd3fa4b5e0bc27988b52595bf3a9a56a36219f9275761d1e4f19.jpeg",
      },
      {
        name: "Shea Butter",
        benefit: "A gentle and effective moisturizer. It contains oleic acid, a saturated fatty acid which is highly compatible with the sebum naturally produced by human skin.",
        image: "https://static.prod-images.emergentagent.com/jobs/76fde4e1-b224-41fa-b1e0-b502822df34b/images/834dd26929a0de306f64c5c263457033eddf5332a44e0448b602f32defa9e784.jpeg",
      },
    ],
    // Tab 2 — same cell system, client line icons (teal, transparent PNG) + title only.
    formulatedWithout: [
      { icon: "/media/icons/derm-formulated.png", title: "Dermatologist-Formulated" },
      { icon: "/media/icons/cruelty-free.png", title: "Cruelty-free" },
      { icon: "/media/icons/fragrance-free.png", title: "Fragrance-free" },
      { icon: "/media/icons/vegan.png", title: "Vegan" },
    ],
    // Tab 3 — full INCI list + formulated-without line + disclaimer.
    fullList: "Eye Repair Treatment Water/Eau, Caprylic/Capric Triglycerides, Propylene Glycol, Shea Butter, Polysorbate 60, Cyclopentasiloxane, Cyclotetrasiloxane, Dimethiconol, Glycerin, Butylene Glycol, Propylene Glycol Alginate, Hinokitiol, Palmitoyl Pentapeptide-4, Hesperidin Methyl Chalcone, N-Hydroxysuccinimide, Chrysin, Tocopheryl Acetate, Sodium Hydroxide, Caprylyl Glycol, Phenoxyethanol, Sodium Tocopheryl Phosphate, Sodium Lauriminodipropionate, Polysorbate 20, Xanthan Gum, Sodium Citrate, Alcohol, Palmitoyl Oligopeptide, Aminopropyl Ascorbyl Phosphate, Steareth-20, Carbomer, Tetrasodium EDTA, Citric Acid, Sorbic Acid.",
    formulatedWithoutLine: "Dermatologist-Formulated · Cruelty-free · Fragrance-free · Vegan",
    fullListDisclaimer: "While Riversol strives to keep ingredient lists on this website as accurate as possible, we cannot guarantee that these lists are complete, reliable, up-to-date, and error-free. Please refer to the ingredients list on the product packaging for the most accurate list of ingredients.",
  },
  clinical: {
    hp3Style: true,
    eyebrow: "Clinically studied",
    titleLines: ["Visible results,", "backed by testing."],
    cols: 3,
    animate: true,
    stats: [
      { value: "87%", num: 87, suffix: "%", label: "experienced more hydrated skin" },
      { value: "81%", num: 81, suffix: "%", label: "noticed fewer fine lines and wrinkles" },
      { value: "1,300+", num: 1300, suffix: "+", label: "verified customer reviews" },
    ],
    disclaimer: "Clinical results based on studies of key active ingredients (22 participants). Review count reflects verified Judge.me reviews.",
  },
  benefits: {
    eyebrow: "What it does",
    titleLines: ["Depuffs, brightens,", "smooths."],
    image: "https://cdn.shopify.com/s/files/1/0821/1399/products/EyeTreatment-KV6sm.png?v=1776097211",
    imageAlt: "Eye Repair Treatment key visual",
    items: [
      "Minimize the look of puffiness",
      "Brighten dark circles",
      "Smooth fine lines and crow's feet",
      "Refine overall eye-area texture",
    ],
  },
  why: {
    eyebrow: "Riversol vs. others",
    title: "Why Riversol Is Different",
    items: [
      "Dermatologist-developed for sensitive skin",
      "Fragrance-free & paraben-free",
      "Signature hinokitiol (Beta-T) antioxidant",
      "Multi-peptide + stabilized Vitamin C blend",
      "Hypoallergenic, low-irritant formula",
      "Lightweight, fast-absorbing texture",
    ],
    comparison: [
      {
        feature: "Dermatologist-developed",
        desc: "By Dr. Rivers, combining clinical expertise with proven skincare science",
      },
      { feature: "Unique antioxidant blend", desc: "" },
      {
        feature: "Photostable Vitamin C",
        desc: "A light-resistant form of Vitamin C that helps improve radiance and even skin tone",
      },
      {
        feature: "Hinokitiol antioxidant support",
        desc: "Riversol's signature antioxidant hinokitiol helps fight free radicals for healthier-looking skin",
      },
      { feature: "Sensitive skin friendly", desc: "Formulated with sensitive skin in mind" },
      { feature: "Made in Canada", desc: "Canadian-made quality you can trust" },
    ],
  },
  highlights: {
    heading: "Skincare Facts",
    items: [
      {
        label: "Dermatologist-Formulated",
        icon: "https://www.riversol.com/cdn/shop/files/icon-testing.svg?width=48",
      },
      {
        label: "Fragrance-free",
        icon: "https://www.riversol.com/cdn/shop/files/icon-fragrance-free.svg?width=48",
      },
      { label: "Hypoallergenic", icon: "https://www.riversol.com/cdn/shop/files/icon-feather.svg?width=48" },
      { label: "Non-comedogenic", icon: "https://www.riversol.com/cdn/shop/files/icon-clog.svg?width=48" },
      { label: "Vegan", icon: "https://www.riversol.com/cdn/shop/files/icon-vegan.svg?width=48" },
      {
        label: "Cruelty-free",
        icon: "https://www.riversol.com/cdn/shop/files/icon-cruelty-free.svg?width=48",
      },
      {
        label: "Made In Canada",
        icon: "https://www.riversol.com/cdn/shop/files/icon-maple-leaf.svg?width=48",
      },
    ],
  },
  details: {
    eyebrow: "The details",
    titleLines: ["Everything else", "you need to know"],
    big: true,
    showClinical: false,
    howTo: [
      "After cleansing, use 1 small pump of eye cream.",
      "Dot the eye cream along the orbital bone, outer corner and under-eye areas.",
      "Do not apply to the eyelid or close to the actual eye, as the product may migrate into the eyes or lash line, potentially causing irritation or clogged oil glands.",
      "Gently pat in.",
      "Wait 2 minutes for Eye Repair Treatment to sink in and fully absorb before applying makeup to the area.",
      "Use within 12 months of opening.",
    ],
    ingredients: "Water/Eau, Caprylic/Capric Triglycerides, Propylene Glycol, Shea Butter, Polysorbate 60, Cyclopentasiloxane, Cyclotetrasiloxane, Dimethiconol, Glycerin, Butylene Glycol, Propylene Glycol Alginate, Hinokitiol, Palmitoyl Pentapeptide-4, Hesperidin Methyl Chalcone, N-Hydroxysuccinimide, Chrysin, Tocopheryl Acetate, Sodium Hydroxide, Caprylyl Glycol, Phenoxyethanol, Sodium Tocopheryl Phosphate, Sodium Lauriminodipropionate, Polysorbate 20, Xanthan Gum, Sodium Citrate, Alcohol, Palmitoyl Oligopeptide, Aminopropyl Ascorbyl Phosphate, Steareth-20, Carbomer, Tetrasodium EDTA, Citric Acid, Sorbic Acid.",
  },
  faq: {
    eyebrow: "Questions, answered",
    title: "Frequently asked Questions",
    items: [
      {
        q: "What is Hinokitiol (Beta-T)?",
        a: "Hinokitiol (Beta-T) is our signature antioxidant found in the Pacific red cedar. Studied for decades for its natural antibiotic, antioxidant, anti-inflammatory and other natural skin-revitalizing properties, hinokitiol helps even skin tone, reduce the look of sun damage and help correct dark spots.",
      },
      {
        q: "Is this suitable for sensitive skin?",
        a: "Yes. Riversol products are dermatologist-developed for sensitive skin. Dr. Jason Rivers first created Riversol for patients who struggled to find skincare that delivered results without unnecessary irritation. That same philosophy guides our fragrance-free, paraben-free formulas, made with low-irritant ingredients chosen to support skin comfort.",
      },
      {
        q: "Can I use this on my eyelids?",
        a: "We recommend avoiding the eyelids, as product can migrate into the eyes or lash line and may lead to irritation or clogged oil glands. This applies to any moisturizing skincare product, not just eye cream.",
      },
      {
        q: "How long should I wait before applying another product?",
        a: "In general, wait 2 minutes before applying additional skincare or makeup. Giving Eye Repair Treatment time to fully absorb helps maximize both immediate and long-term results.",
      },
    ],
  },
  final: {
    eyebrow: "Bright, refreshed eyes",
    titleLines: ["Eye Repair", "Treatment"],
    image: "https://cdn.shopify.com/s/files/1/0821/1399/products/eye-repair.png?v=1776097214",
    imageAlt: "Eye Repair Treatment",
    imageMode: "contain",
  },
  routineWideBanner: false,
  beforeAfter: {
    eyebrow: "Real Results",
    heading: "8 weeks with Eye Repair",
    copy: "",
    before: "https://static.prod-images.emergentagent.com/jobs/76fde4e1-b224-41fa-b1e0-b502822df34b/images/2ffcd269f3baccd5a97f05f910503a3419f951ea107e8e132d4614cadae2f815.jpeg",
    after: "https://static.prod-images.emergentagent.com/jobs/76fde4e1-b224-41fa-b1e0-b502822df34b/images/2541fc9448f440cf4de74cd1d9eb2269a5bcf1384e46e39a5afc967e3664a44f.jpeg",
    note: "",
  },
  beforeAfterSection: {
    heading: "See the difference.",
    body: "Eight weeks of Eye Repair Treatment, morning and night. Drag the slider to compare — consistent use is what brings the visible change.",
  },
  howToPoster: "/media/how_to_use.webp",
  howToParagraph: [
    "Use a pea-sized amount. Apply over the entire face, except the eye area. Use twice a day, morning and night, after cleansing and serum application.",
    "Please remember this is a concentrated formulation and only a small amount is recommended per application.",
    "Use within 12 months of opening.",
  ],
  whenToUseBlock: {
    label: "When to use",
    frequency: "Twice daily",
    slots: [
      { label: "AM", icon: "sun" },
      { label: "PM", icon: "moon" },
    ],
  },
  memberNudge: {
    text: "Receive exclusive perks with",
    brand: "Riversol+",
    signUpLabel: "Sign Up",
    signUpHref: "#",
    or: "or",
    signInLabel: "Sign In",
    signInHref: "#",
  },
  breadcrumbs: [
    { label: "Home", href: "/hp3" },
    { label: "Shop", href: "#" },
    { label: "Eye Care", href: "#" },
  ],
  heroBadge: "Best Seller",
};

export default PDP_3_4_CONTENT;
